/** Long-form SEO/marketing copy shown beneath the signup or login form. */
export function AuthIntroCopy({ mode }) {
  if (mode === 'signup') {
    return (
      <div className="mt-8 space-y-3 max-w-md" data-testid="signup-intro-copy">
        <h2 className="font-heading text-base text-[#F2F2F2]">What you get with your free Final Frame account</h2>
        <p className="text-[#A0A0A0] font-body text-sm leading-relaxed">
          Final Frame is production management software built for indie, student, and small-crew filmmakers. Your free account gives you one active project with script upload and PDF text extraction, a limited script breakdown (up to 15 tagged elements across cast, props, wardrobe, locations, SFX and VFX), a drag-and-drop shooting schedule, shot list tracking, cast &amp; crew contact management, location scouting with weather forecasts, and clean PDF exports for call sheets and shooting schedules.
        </p>
        <p className="text-[#A0A0A0] font-body text-sm leading-relaxed">
          You can send call sheets to your cast and crew by email, and upgrade to Pro or Pro+ any time to unlock SMS delivery (Twilio A2P 10DLC compliant), Exhibit G daily casting reports, wrap reports, budget planning, live expense tracking, and team collaboration for up to four members. There is no time limit on the free tier &mdash; use it for as long as you like.
        </p>
        <p className="text-[#A0A0A0] font-body text-sm leading-relaxed">
          Signing up takes about thirty seconds. Enter your name, email, and a password &mdash; or continue with Google. No credit card, no trial timer, no dark patterns.
        </p>
      </div>
    );
  }

  return (
    <div className="mt-8 space-y-3 max-w-md" data-testid="login-intro-copy">
      <h2 className="font-heading text-base text-[#F2F2F2]">Sign in to continue your production</h2>
      <p className="text-[#A0A0A0] font-body text-sm leading-relaxed">
        Sign in to Final Frame to access your saved indie film projects, script breakdowns, drag-and-drop shooting schedules, shot lists, call sheets, wrap reports, and Exhibit G daily casting reports. Your work auto-saves as you go, so you can pick up on any device exactly where you left off.
      </p>
      <p className="text-[#A0A0A0] font-body text-sm leading-relaxed">
        Forgot your password? Use the reset link on the form, or contact us at <a href="mailto:info@finalframe.site" className="text-[#D6B36A] hover:underline">info@finalframe.site</a> and we&rsquo;ll help you back in.
      </p>
    </div>
  );
}
